<template>
    <router-view />
</template>

<script>
//import FingerprintJS from '@fingerprintjs/fingerprintjs'
//import axios from 'axios';
import { DeviceUUID } from 'device-uuid';
export default {
  data() {
    return {
      email: localStorage.getItem("username"),
      password: localStorage.getItem("password"),
      db_guid: localStorage.getItem("db_guid"),
      uid: new DeviceUUID().get(),
    }
  },
  async created(){
    if((localStorage.getItem('username2') == null || localStorage.getItem('username2') == '') && (localStorage.getItem('password2') == null || localStorage.getItem('password2') == '')){
          this.$router.push({name:'login'})
          return;        
    }else if(this.db_guid == ''){
          this.$router.push({name:'login'})
          return;
        }
    else
    this.$router.push({ name: localStorage.getItem("CurrentPage") == null ? 'Dashboard' : localStorage.getItem("CurrentPage")});
    /*try{
      console.log('create indexPage')
      const fp = await FingerprintJS.load()
      const result = await fp.get()
      const visitorId = result.visitorId
    if((localStorage.getItem('username2') == null || localStorage.getItem('username2') == '') && (localStorage.getItem('password2') == null || localStorage.getItem('password2') == '')){
          this.$router.push({name:'login'})
          return;        
    }
    let response = () => {
        if (localStorage.getItem('password') == null)
          this.password = '';
        else
          this.password = localStorage.getItem('password');
        if (localStorage.getItem('username') == null)
          this.email = '';
        else
          this.email = localStorage.getItem('username');
        if (this.email == '' && this.password == '' )
          return;
        if(this.db_guid == ''){
          this.$router.push({name:'login'})
          return;
        }
        var str = 'method%3DWEB_Login_Check%26username%3D' + this.email + '%26password%3D' + this.password + '%26android_id%3D' + this.uid + '%26db_guid%3D' + this.db_guid+'%26SESSION%3D' + visitorId  +'%26token%3D' + localStorage.getItem('token') ;
        var ip ='';
        if(localStorage.getItem('BCloud')=='true'){
          str +="%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") ;
          str = {Username:localStorage.getItem("username2"), Password:localStorage.getItem("password2"),url:str,SESSION:localStorage.getItem('session')};            
          ip = localStorage.getItem("ip");
        }else{
          str +="%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") +'%26Ip%3D' + visitorId;              
          ip = localStorage.getItem("ip2");
        }
        return new Promise(function (resolve) {
          axios.post(ip, str,
            {
              'Content-type': 'plain/text'
            }).then(response => {
              resolve(response);
            });
        });
      };
      let responseData = await response();
      if (responseData.data[0]['State'] == true) {
        localStorage.setItem("X", responseData.data[0]['db_guid']);
        this.$router.push({ name: localStorage.getItem("CurrentPage") == null ? 'Dashboard' : localStorage.getItem("CurrentPage")});
      } else {
        var t = localStorage.getItem('token');
        //localStorage.clear();
        localStorage.setItem('token',t);
        await this.$swal.fire({
              //  title: "Are you sure?",
              text: responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'],
              icon: "error",
              //iconHtml: "!",
              //showCancelButton: true,
              showConfirmButton: false,
              confirmButtonColor: "#d33",
              confirmButtonText: "OK",
              timer: 5000
            });
        
        //this.$router.push({name:'login'})
      }
    }catch(ex){
      //this.$router.push({name:'login'})
    }*/
    
  }
  };
</script>